/**
 * PARTNERS CONFIG
 * ──────────────────────────────────────────────────────────────────
 * To add, remove, or reorder partners — edit ONLY this file.
 * Logos auto-flow into a 4-column grid. Just add/remove entries.
 *
 * Each entry:
 *   name     — display name / alt text
 *   href     — link when clicked (use '#' as placeholder)
 *   logo     — image URL or import (null = use label text instead)
 *   label    — text shown when no logo image
 *   sublabel — (optional) smaller line below label
 *   style    — (optional) inline styles for text logos
 */

import planningPortalLogo from '../../../../assets/PlanningPortalSVG.svg';

const PARTNERS = [
  { name: 'Planning Portal', href: 'https://www.planningportal.co.uk', logo: planningPortalLogo, label: 'Planning Portal', style: { fontWeight: 700, fontSize: 18 } },
];

export default PARTNERS;
